import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Login } from '../app/auth/component/Login'
import { ResetPassword } from '../app/auth/component/ResetPassword'
import { AuthLayout } from '../app/shared/component/layout/AuthLayout'
import { ProtectedLayout } from '../app/shared/component/layout/ProtectedLayout'
import { Dashboard } from '../app/shared/component/dashboard/Dashboard'
import { Signup } from '../app/auth/component/Signup'
import { Profile } from '../app/user/component/Profile'
import { Settings } from '../app/shared/component/Settings'
import { ContactPage } from '../app/contact/component/ContactPage'
import { ItemPage } from '../app/inventory/component/ItemPage'
import { OrderPage } from '../app/order/component/OrderPage'
import { AppraisalPage } from '../app/appraisal/component/AppraisalPage'
import { WeddingRegistryPage } from '../app/wedding-registry/component/WeddingRegistryPage'
import { SalesByVendorPage } from '../app/reports/sales-by-vendor/component/SalesByVendorPage';
import { InventoryStoneManagementReport } from '../app/inventory/component/InventoryStoneManagementReport'
import { AppointmentList } from '../app/appointment/component/AppointmentList'
import { ServiceTypeList } from '../app/appointment/component/ServiceTypeList'
import { TicketList } from '../app/ticket/component/TicketList'
import { OnlineOrderList } from '../app/order/component/OnlineOrderList'
import {
  SalesByCustomerServerRenderingPage
} from '../app/reports/sales-by-customer/component/SalesByCustomerServerRenderingPage'
import {
  OrderPaymentsPageServerRendering
} from '../app/reports/order-payments/component/OrderPaymentsPageServerRendering'
import { OrderPaymentsLegacy } from '../app/reports/order-payments/component/OrderPaymentsLegacy'
import { SalesByCustomerLegacy } from '../app/reports/sales-by-customer/component/SalesByCustomerLegacy'
import { InventoryByManufactureReport } from '../app/inventory/component/InventoryByManufactureReport'
import { InventoryByPatternReport } from '../app/inventory/component/InventoryByPatternReport'
import {
  SalesByVendorPageServerRendering
} from '../app/reports/sales-by-vendor/component/SalesByVendorPageServerRendering'
import { NewArrivalsList } from '../app/shop/component/NewArrivalsList'
import { ItemUploadImages } from '../app/inventory/component/ItemUploadImages'
import MassChangeMain from '../app/shop/component/MassChangeMain'
import { PurchaseOrderEntry } from '../app/inventory/component/PurchaseOrderEntry'
import { PurchaseOrderList } from '../app/inventory/component/PurchaseOrderList'
import { PurchaseOrderDetailPage } from '../app/inventory/component/PurchaseOrderDetailPage'
import { BackOrderReport } from '../app/reports/BackOrderReport'
import DeliverableReport from '../app/reports/DeliverableRepost'
import { ImageSlider } from '../app/shop/component/ImageSlider'
import { CarouselManagement } from '../app/shop/component/CarouselManagement'
import { BannerList } from '../app/shop/component/BannerList'
import { BlogForm, BlogList } from '../app/shop/component'
import { TrendingJewelryList } from '../app/shop/component/TrendingJewelryList'
import { TrendingWatchList } from '../app/shop/component/TrendingWatchList'
import { ItemCategoryListPage } from '../app/inventory/component/ItemCategoryListPage'
import { OnlinePaymentList } from '../app/website/component/OnlinePaymentList'
import { FilterConfigPage } from '../app/filter-config/component/FilterConfigPage'
import { ShippingMethodList } from '../app/shipping/component/ShippingMethodList'

const routes = {
  authRoutes: [
    {path: '/login', element: <Login/>},
    {path: '/reset-password', element: <ResetPassword/>},
    {path: '/signup', element: <Signup/>},
  ],

  privateRoutes: [
    {path: '/', element: <Dashboard/>},
    {path: '/appraisal/:number?', element: <AppraisalPage/>},
    {path: '/inventory/:sku?', element: <ItemPage/>},
    {path: '/vendor', element: <h1>Vendor</h1>},
    {path: '/order/:number?', element: <OrderPage/>},
    {path: '/online-orders', element: <OnlineOrderList/>},
    {path: '/online-payments', element: <OnlinePaymentList/>},
    {path: '/wedding-registery', element: <WeddingRegistryPage/>},
    {path: '/upload-images', element: <ItemUploadImages/>},
    {path: '/reports/sales-by-customer/legacy', element: <SalesByCustomerLegacy/>},
    {path: '/reports/sales-by-customer', element: <SalesByCustomerServerRenderingPage/>},
    {path: '/reports/sales-by-vendor/legacy', element: <SalesByVendorPage/>},
    {path: '/reports/sales-by-vendor', element: <SalesByVendorPageServerRendering/>},
    {path: '/reports/order-payments/legacy', element: <OrderPaymentsLegacy/>},
    {path: '/reports/order-payments', element: <OrderPaymentsPageServerRendering/>},
    {path: '/reports/stone-inventory-management', element: <InventoryStoneManagementReport/>},
    {path: '/reports/inventory-by-manufacture', element: <InventoryByManufactureReport/>},
    {path: '/reports/inventory-by-pattern', element: <InventoryByPatternReport/>},
    {path: '/reports/back-order', element: <BackOrderReport/>},
    {path: '/reports/received-back-orders', element: <DeliverableReport/>},
    {path: '/purchase-order', element: <PurchaseOrderList/>},
    {path: '/purchase-order/new', element: <PurchaseOrderEntry/>},
    {path: '/purchase-order/:poNumber', element: <PurchaseOrderDetailPage/>},
    {path: '/appointments', element: <AppointmentList/>},
    {path: '/appointments/service-types', element: <ServiceTypeList/>},
    {path: '/tickets', element: <TicketList/>},

    {path: '/profile', element: <Profile/>},
    {path: '/contact/:contactId?', element: <ContactPage/>},
    {path: '/receivables', element: <h1>Receivables</h1>},
    {path: '/settings', element: <Settings/>},
    {path: '/admin/new-arrivals', element: <NewArrivalsList/>},
    {path: '/admin/trending-jewelry', element: <TrendingJewelryList/>},
    {path: '/admin/trending-watch', element: <TrendingWatchList/>},
    {path: "/admin/mass-change", element: <MassChangeMain/>},
    {path: '/admin/carousels', element: <CarouselManagement/>},
    {path: '/admin/product-filters', element: <FilterConfigPage/>},
    {path: '/admin/shipping-methods', element: <ShippingMethodList/>},
    {path: 'admin/image-slider', element: <ImageSlider/>},
    {path: 'admin/banner', element: <BannerList/>},
    {path: 'admin/blogs', element: <BlogList/>},
    {path: 'admin/blogs/new', element: <BlogForm/>},
    {path: 'admin/blogs/:id/edit', element: <BlogForm/>},
    {path: 'admin/item-categories', element: <ItemCategoryListPage/>},
  ],
}

export function AppRoutes() {
  return (
    <>
      <BrowserRouter>
        <div className='App'>
          <Routes>
            <Route element={<AuthLayout/>}>
              {routes.authRoutes.map((route, index) => (
                <Route
                  key={`auth-${index}`}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>

            <Route element={<ProtectedLayout/>}>
              {routes.privateRoutes.map((route, index) => (
                <Route
                  key={`private-${index}`}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>
          </Routes>
        </div>
      </BrowserRouter>
    </>
  )
}
